import React from 'react';
import './AboutSection.css';

const stats = [
  { num: '2',    label: 'Crops Supported' },
  { num: '15+',  label: 'Diseases Classified' },
  { num: '98%',  label: 'Detection Accuracy' },
  { num: '2026', label: 'Project Year' },
];

const team = [
  { emoji: '👨‍💻', name: 'Syed Sikander Ali', id: 'F22BSEEN1M01207', role: 'Full Stack Developer' },
  { emoji: '👨‍🔬', name: 'Muhammad Irtaza',   id: 'F22BSEEN1M0118',  role: 'ML Engineer' },
];

export default function AboutSection() {
  return (
    <section id="about">
      <div className="container">
        <div className="row g-5 align-items-center">

          {/* ── Left ── */}
          <div className="col-lg-6 reveal">
            <span className="section-label">Our Story</span>
            <h2 className="section-title mb-4">
              Built at <span className="accent">Islamia University</span><br />of Bahawalpur
            </h2>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.8, marginBottom: 20 }}>
              CropGuard AI is a final-year project by undergraduate Software Engineering students
              at the Department of Software Engineering, Faculty of Computing. Supervised by{' '}
              <strong style={{ color: 'var(--cream)' }}>Ms. Rubab Sheikh</strong>, the project
              was built to address the urgent need for accessible, low-cost crop disease diagnosis
              in rural Pakistan.
            </p>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.8, marginBottom: 32 }}>
              Pakistan is one of the world's largest producers of tomatoes and maize. Yet each year,
              thousands of smallholder farmers suffer significant losses due to undetected plant diseases.
              CropGuard AI puts the diagnostic power of modern artificial intelligence directly into
              the hands of every farmer — for free.
            </p>
            <div className="row g-3">
              {stats.map((s, i) => (
                <div className="col-6" key={i}>
                  <div className="about-stat">
                    <div className="big-num">{s.num}</div>
                    <p>{s.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Right: Team ── */}
          <div className="col-lg-6 reveal">
            <div className="text-center mb-4">
              <h4 style={{ color: 'var(--cream)', fontFamily: 'Playfair Display,serif' }}>
                Meet the Development Team
              </h4>
            </div>
            <div className="row g-3">
              {team.map((m, i) => (
                <div className="col-md-6" key={i}>
                  <div className="team-card">
                    <div className="team-avatar">{m.emoji}</div>
                    <div className="team-name">{m.name}</div>
                    <div className="team-id">{m.id}</div>
                    <div className="team-role">{m.role}</div>
                  </div>
                </div>
              ))}
              <div className="col-12">
                <div className="team-card">
                  <div className="team-avatar">👩‍🏫</div>
                  <div className="team-name">Ms. Rubab Sheikh</div>
                  <div className="team-id">Project Supervisor</div>
                  <div className="team-role">Department of Software Engineering</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
